import { Observable } from 'rxjs';

export interface User {
  email: string;
  profilePic?: string;
  address?: string;
  uid: string;
  name: string;
  menuFiles?: any;
  plan?: string;
  companyName: string;
  phone: string;
  password?: string;
  userType: string;
  newUser?: boolean;
  active?: boolean;
  confirmPassword?: string;
  saveDataFor?: number;
  terms?: boolean;
  timestamp?: number;
  checkinCount?: number;
  lang?: string;
  timezoneOffset?
}


export abstract class UserData {
  abstract invoices();
  abstract updateLoggedUser();
  abstract getFlyers(language: string);
  abstract getCurrentUser();
  abstract createUser(user: User);
  abstract signUp(user: User);
  abstract getUsers(pagination,filter,order);
  abstract getUser(id: string);
  abstract getPromotions();
  abstract editUser(data: User,id: string);
}
